export default "__VITE_ASSET__zK2uKwDv__"